import type { LumpsumPlanRecommendationTaxData } from '../../api/recommendation.types'
import {
  ExitLoadTaxLiabilityAccordion,
  ExitLoadTaxLiabilityAccordionIcon
} from './ExitLoadTaxLiabilityAccordion'

export type PlanTaxLiabilityTax = {
  taxData: LumpsumPlanRecommendationTaxData | null
  withdrawalAmount: number
  currentValue: number | null
}

type PlanTaxLiabilityProps = {
  isOutside: boolean
  tax: PlanTaxLiabilityTax
  areAllSellActionsCompleted?: boolean
  fundName?: string
  fundIsin?: string
}

export function PlanTaxLiability({
  isOutside,
  tax,
  areAllSellActionsCompleted = false,
  fundName = '',
  fundIsin = ''
}: PlanTaxLiabilityProps) {
  // Inside: top border = same divider as Reasons / Steps. Outside: gray band separates instead.
  const showBorderTop = !isOutside

  const content = areAllSellActionsCompleted ? (
    <ExitLoadTaxLiabilitySellsCompleted showBorderTop={showBorderTop} />
  ) : (
    <ExitLoadTaxLiabilityAccordion
      taxData={tax.taxData}
      withdrawalAmount={tax.withdrawalAmount}
      currentValue={tax.currentValue}
      isBorderTop={showBorderTop}
      fundName={fundName}
      fundIsin={fundIsin}
    />
  )

  if (!isOutside) {
    return content
  }

  return (
    <>
      <div className="h-3 bg-[#F0F4F7]" aria-hidden />
      <div className="pt-2">
        <div className="px-5 pb-2 pt-4 text-[18px] font-[500] leading-[130%] text-[#232323]">
          Taxation
        </div>
        {content}
      </div>
    </>
  )
}

export function areAllSellActionsCompleted(
  sellFunds: { executed?: boolean | null }[] | null | undefined
): boolean {
  const funds = sellFunds ?? []
  return funds.length > 0 && funds.every((fund) => fund?.executed === true)
}

export function ExitLoadTaxLiabilitySellsCompleted({
  showBorderTop = false
}: {
  showBorderTop?: boolean
}) {
  return (
    <div
      className={`flex min-h-[74px] w-full items-center gap-4 px-5 py-4${
        showBorderTop ? ' border-t border-[#EBF2F2]' : ''
      }`}
    >
      <ExitLoadTaxLiabilityAccordionIcon />
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="text-[14px] font-[500] leading-[130%] text-[#232323]">
          Exit Load & Tax Liability
        </div>
        <div className="text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
          All sell actions are completed. No further taxes and exit load are applicable.
        </div>
      </div>
    </div>
  )
}
